import { render } from "./MerchantManageEditForm.vue?vue&type=template&id=cb882a20&lang=true"
import script from "./MerchantManageEditForm.vue?vue&type=script&lang=js"
export * from "./MerchantManageEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__